import React, { useState } from 'react';
import { Message } from '@getro/rombo';
import { Box, Text } from 'rebass/styled-components';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { SignInForm } from '../../../../components/molecules/signInForm';
import { SocialOAuthButtons } from '../../../../components/molecules/socialOAuthButtons';
import { openChat } from '../../../../helpers/supportChat';

export const SignIn = ({ routePath, sharedList }) => {
  const [oAuthError, setOAuthError] = useState(null);
  const history = useHistory();

  const onClickGoToSignUp = () => {
    history.push(`${routePath}`);
  };

  const onSuccess = () => {
    setOAuthError(null);
    history.push(`/shared-company-lists/${sharedList.slug}`);
  };

  return (
    <>
      <Box pb="64px">
        <Text fontSize="22px" fontWeight="semibold" color="text.dark">
          Find who you know at these companies
        </Text>
        <Text mt="16px" mb="32px">
          Connect your LinkedIn to easily find warm intros and offer help.
        </Text>
        <SocialOAuthButtons
          mt="64px"
          onSuccess={onSuccess}
          onError={(e) => {
            setOAuthError(e);
          }}
        />
        {!!oAuthError && (
          <Message
            mt="8px"
            type="error"
            content={
              oAuthError?.status === 401 ? (
                oAuthError.data?.error
              ) : (
                <Text>
                  There was an unexpected error, please try again or{' '}
                  <Text as="span" sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={openChat}>
                    contact us
                  </Text>
                  .
                </Text>
              )
            }
          />
        )}
        <Box mt="40px" pb="16px" sx={{ position: 'relative' }}>
          <Box width="160px" my="0" mx="auto" sx={{ borderTop: '1px solid', borderColor: 'border.subtle' }} />
          <Text
            px="24px"
            fontWeight="medium"
            fontSize="14px"
            color="text.subtle"
            width="fit-content"
            bg="neutral.0"
            sx={{ position: 'absolute', top: '-8px', left: '50%', transform: 'translateX(-50%)' }}
          >
            OR
          </Text>
        </Box>
        <SignInForm onSuccess={onSuccess} />
      </Box>
      <Box sx={{ position: 'absolute', bottom: '24px', left: '0', right: '0' }}>
        <Text as="p" fontSize="14px" width="100%" color="text.subtle" sx={{ textAlign: 'center' }}>
          Don’t have a Getro account?{' '}
          <Text as="span" sx={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={onClickGoToSignUp}>
            Sign up.
          </Text>
        </Text>
      </Box>
    </>
  );
};

SignIn.propTypes = {
  routePath: PropTypes.string.isRequired,
  sharedList: PropTypes.object.isRequired,
};
